function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgInfo = function SvgInfo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({}, props, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.76 2a9.974 9.974 0 0 0-7 3.1A9.978 9.978 0 0 0 2 12.24C2.13 17.67 6.59 22 12 22h.24a9.974 9.974 0 0 0 7-3.1A9.978 9.978 0 0 0 22 11.76c-.14-5.51-4.71-9.9-10.24-9.76zM13 16c0 .55-.45 1-1 1s-1-.45-1-1v-4c0-.55.45-1 1-1s1 .45 1 1v4zm.23-7.76c-.02.08-.04.16-.08.24-.03.07-.07.15-.11.21-.05.07-.1.14-.16.19-.23.24-.55.37-.88.37s-.65-.13-.88-.37c-.06-.05-.11-.12-.16-.19a1.39 1.39 0 0 1-.11-.21c-.04-.08-.06-.16-.08-.24-.01-.08-.02-.16-.02-.24 0-.33.13-.65.37-.88.05-.06.12-.11.19-.16.06-.04.14-.08.21-.11.08-.04.16-.06.24-.08.4-.08.83.06 1.12.35.24.23.37.55.37.88 0 .08-.01.16-.02.24z",
    style: {
      fill: "#fff"
    }
  }));
};

export default SvgInfo;